// src/models/experienceFlow/astrazeneca.ts
const buildExperienceFlowAstrazenecaParams = () => {
	return {
		empty: null,
		sponsorScreenAfterClassSelection: true
	};
};

export { buildExperienceFlowAstrazenecaParams };
//# sourceMappingURL=astrazeneca.mjs.map